var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7703_48986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05201 11.1833C9.05239 11.0939 9.03422 11.0053 8.99865 10.9233C8.96308 10.8412 8.91087 10.7675 8.84534 10.7066L4.86667 7.03595L0.886673 10.7066C0.82126 10.7675 0.769182 10.8413 0.733726 10.9234C0.69827 11.0054 0.680205 11.0939 0.680673 11.1833V14.7633C0.680673 14.9341 0.748523 15.0979 0.869296 15.2187C0.99007 15.3394 1.15387 15.4073 1.32467 15.4073H8.40867C8.57947 15.4073 8.74328 15.3394 8.86405 15.2187C8.98482 15.0979 9.05267 14.9341 9.05267 14.7633L9.05201 11.1833ZM11.3313 5.15062C11.6339 5.15579 11.9345 5.10067 12.2155 4.98846C12.4965 4.87626 12.7524 4.70921 12.9682 4.49707C13.184 4.28494 13.3554 4.03195 13.4724 3.75288C13.5894 3.4738 13.6497 3.17422 13.6497 2.87162C13.6497 2.56901 13.5894 2.26943 13.4724 1.99036C13.3554 1.71129 13.184 1.4583 12.9682 1.24616C12.7524 1.03403 12.4965 0.866981 12.2155 0.754774C11.9345 0.642567 11.6339 0.587443 11.3313 0.592619C10.7337 0.602841 10.1639 0.847444 9.74487 1.27373C9.32581 1.70001 9.09099 2.27385 9.09099 2.87162C9.09099 3.46938 9.32581 4.04323 9.74487 4.46951C10.1639 4.89579 10.7337 5.1404 11.3313 5.15062Z",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9488 15.4073H13.0408L13.6108 10.8486H15.3201V9.13998C15.3201 8.27598 15.0395 7.43535 14.5206 6.74453C14.0017 6.05371 13.2725 5.55005 12.4428 5.30932C11.613 5.06859 10.7275 5.1038 9.91943 5.40965C9.11138 5.71551 8.42449 6.27547 7.96208 7.00531M4.86608 10.422V13.6446M6.47742 12.0333H3.25342",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7703_48986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitIcon);
export default __webpack_public_path__ + "static/media/visitIcon.119c094f156432850d200e8e60323c17.svg";
export { ForwardRef as ReactComponent };